"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signup = signup;
exports.login = login;
exports.logout = logout;
exports.getCurrentUser = getCurrentUser;
exports.updateProfile = updateProfile;
exports.getSavedListings = getSavedListings;
exports.saveListing = saveListing;
exports.removeSavedListing = removeSavedListing;
exports.removeSessionSavedListing = removeSessionSavedListing;
exports.listSessionSavedListings = listSessionSavedListings;
exports.getSavedSearches = getSavedSearches;
exports.saveSearch = saveSearch;
exports.listSavedSearchRevisions = listSavedSearchRevisions;
exports.updateSavedSearch = updateSavedSearch;
exports.deleteSavedSearch = deleteSavedSearch;
exports.listSessionSavedSearches = listSessionSavedSearches;
exports.mergeGuestActivity = mergeGuestActivity;
exports.getBuyerProfile = getBuyerProfile;
exports.patchBuyerProfile = patchBuyerProfile;
const http_js_1 = require("./http.js");
function withSessionCredentials(options = {}) {
    return {
        credentials: "include",
        ...options,
        headers: { ...options.headers },
    };
}
function authPath(slug, suffix) {
    return `/api/v1/views/${encodeURIComponent(slug)}${suffix}`;
}
async function signup(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/auth/signup"), { ...withSessionCredentials(options), method: "POST", body: payload });
}
async function login(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/auth/login"), { ...withSessionCredentials(options), method: "POST", body: payload });
}
async function logout(slug, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/auth/logout"), {
        ...withSessionCredentials(options),
        method: "POST",
        body: {},
    });
}
async function getCurrentUser(slug, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/auth/me"), withSessionCredentials(options));
}
async function updateProfile(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me"), {
        ...withSessionCredentials(options),
        method: "PUT",
        body: payload,
    });
}
async function getSavedListings(slug, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me/saved-listings"), withSessionCredentials(options));
}
async function saveListing(slug, payload, options = {}) {
    const authenticated = !options.anonymous;
    const path = authenticated
        ? authPath(slug, "/me/saved-listings")
        : authPath(slug, "/session/saved-listings");
    const requestOptions = authenticated
        ? withSessionCredentials(options)
        : { ...options, credentials: options.credentials ?? "include" };
    return (0, http_js_1.publicRequest)(path, {
        ...requestOptions,
        method: "POST",
        body: payload,
    });
}
async function removeSavedListing(slug, savedListingId, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, `/me/saved-listings/${encodeURIComponent(savedListingId)}`), { ...withSessionCredentials(options), method: "DELETE" });
}
async function removeSessionSavedListing(slug, savedListingId, visitorId, options = {}) {
    const query = (0, http_js_1.buildQuery)({ visitorId });
    return (0, http_js_1.publicRequest)(`${authPath(slug, `/session/saved-listings/${encodeURIComponent(savedListingId)}`)}${query}`, { ...options, credentials: options.credentials ?? "include", method: "DELETE" });
}
async function listSessionSavedListings(slug, visitorId, options = {}) {
    const query = (0, http_js_1.buildQuery)({ visitorId });
    return (0, http_js_1.publicRequest)(`${authPath(slug, "/session/saved-listings")}${query}`, { ...options, credentials: options.credentials ?? "include" });
}
async function getSavedSearches(slug, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me/saved-searches"), withSessionCredentials(options));
}
async function saveSearch(slug, payload, options = {}) {
    const authenticated = !options.anonymous;
    const path = authenticated
        ? authPath(slug, "/me/saved-searches")
        : authPath(slug, "/session/saved-searches");
    const requestOptions = authenticated
        ? withSessionCredentials(options)
        : { ...options, credentials: options.credentials ?? "include" };
    return (0, http_js_1.publicRequest)(path, {
        ...requestOptions,
        method: "POST",
        body: payload,
    });
}
async function listSavedSearchRevisions(slug, savedSearchId, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, `/me/saved-searches/${encodeURIComponent(savedSearchId)}/revisions`), withSessionCredentials(options));
}
async function updateSavedSearch(slug, savedSearchId, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, `/me/saved-searches/${encodeURIComponent(savedSearchId)}`), { ...withSessionCredentials(options), method: "PUT", body: payload });
}
async function deleteSavedSearch(slug, savedSearchId, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, `/me/saved-searches/${encodeURIComponent(savedSearchId)}`), { ...withSessionCredentials(options), method: "DELETE" });
}
async function listSessionSavedSearches(slug, visitorId, options = {}) {
    const query = (0, http_js_1.buildQuery)({ visitorId });
    return (0, http_js_1.publicRequest)(`${authPath(slug, "/session/saved-searches")}${query}`, { ...options, credentials: options.credentials ?? "include" });
}
async function mergeGuestActivity(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me/merge-guest-activity"), { ...withSessionCredentials(options), method: "POST", body: payload });
}
async function getBuyerProfile(slug, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me/buyer-profile"), withSessionCredentials(options));
}
async function patchBuyerProfile(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(authPath(slug, "/me/buyer-profile"), { ...withSessionCredentials(options), method: "PATCH", body: payload });
}
